import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DialogContextType } from "../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: t("saveQLSLayer.title", { ns: "dialogs" }),
        icon: null,
      },
      meta: {
        aliasLabel: t("newLayer.layerName", { ns: "dialogs" }),
        descriptionLabel: t("newLayer.layerDescription", { ns: "dialogs" }),
        loaderLabel: t("newLayer.imageForCatalog", { ns: "dialogs" }),
      },
      applyText: t("actions.save", { ns: "common" }),
    }),
    [t],
  );
};
